import { Component, OnInit, ChangeDetectionStrategy, inject, signal }           from '@angular/core';
import { InfluencerApiService } from '@app/services/api/influencer-api.service';
import { ActivatedRoute, Router } from '@angular/router';
import {select, Store} from '@ngrx/store';
import {getLoggedInUser, IAuthenticationState} from '@app/stores';
import { NgbNav, NgbNavContent, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavOutlet } from '@ng-bootstrap/ng-bootstrap';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { SocialSharePreviewComponent } from '../../shared/social-share-preview/social-share-preview.component';

@Component({
  selector: 'app-share-event',
  templateUrl: './share-project.component.html',
  styleUrls: ['./share-project.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgbNav, NgbNavItem, NgbNavItemRole, NgbNavLink, NgbNavLinkBase, NgbNavContent, NgbNavOutlet, FaIconComponent, SocialSharePreviewComponent]
})
export class ShareProjectComponent implements OnInit {
  private authenticationStore = inject<Store<IAuthenticationState>>(Store);
  private influencersApiService = inject(InfluencerApiService);
  private activatedRoute = inject(ActivatedRoute);

  currentUser: any;
  projectId: any;
  shareInfo: any;
  readonly personalizedMessage = signal<string>(undefined);
  readonly title = signal<string>(undefined);
  readonly description = signal<string>(undefined);
  readonly landingPageUrl = signal<string>(undefined);
  readonly image = signal<string>(undefined);
  readonly emailTitle = signal<string>(undefined);
  readonly emailBody = signal<string>(undefined);

  constructor() {
    this.authenticationStore.pipe(select(getLoggedInUser)).subscribe(user => {
      this.currentUser = user;
      this.getInfluencerInfo();
    }
    );
    this.activatedRoute.params.subscribe(params => {
      this.projectId = params.projectId;
      this.getInfluencerInfo();
    });
  }

  ngOnInit() {
  }

  getInfluencerInfo() {
    if (!this.projectId || !this.currentUser) {
      return;
    }
    if (this.shareInfo) {
      return;
    }
    // Only an influencer's login carries its influencers: anyone else has nothing to share here.
    const influencers = this.currentUser.user?.influencers || [];
    const influencer = influencers.find(i => String(i.segment?.project_id) === String(this.projectId));
    if (!influencer) {
      return;
    }
    this.influencersApiService.getShareInfo(influencer.id).subscribe(response => {
      if (response.body.Success) {
        this.personalizedMessage.set(response.body.personalized_message);
        this.title.set(response.body.landing_page.meta.title);
        this.description.set(response.body.landing_page.meta.description);
        this.image.set(response.body.landing_page.meta.image);
        this.landingPageUrl.set(response.body.landing_page_url);
        this.emailTitle.set(response.body.email.email_title);
        this.emailBody.set(response.body.email.email_body);
      }
    });
  }

  facebookURL() {
    return `https://www.facebook.com/sharer/sharer.php?u=${this.landingPageUrl()}`;
  }

  twitterURL() {
    return `https://twitter.com/intent/tweet?url=${this.landingPageUrl()}&text=${this.personalizedMessage()}`;
  }

  linkedinURL() {
    return `https://www.linkedin.com/sharing/share-offsite/?url=${this.landingPageUrl()}`;
  }

  whatsappURL() {
    return `https://www.linkedin.com/sharing/share-offsite/?url=${this.landingPageUrl()}`;
  }

  slackURL() {
    return `https://www.linkedin.com/sharing/share-offsite/?url=${this.landingPageUrl()}`;
  }

  emailURL() {
    return `mailto:?subject=${this.emailTitle()}&body=${this.emailBody()}`;
  }
}
